import { render, staticRenderFns } from "./CustomAttributesList.vue?vue&type=template&id=15ca34c0&scoped=true"
import script from "./CustomAttributesList.vue?vue&type=script&lang=ts"
export * from "./CustomAttributesList.vue?vue&type=script&lang=ts"
import style0 from "./CustomAttributesList.vue?vue&type=style&index=0&id=15ca34c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ca34c0",
  null
  
)

export default component.exports